import Swal from "sweetalert2"
import faradayApi from "../../api/faradayApi"


export const addOpportunity = async (formValues, succesMsg, errorMsg, navigate) => {

    try {
        const { data } = await faradayApi.post('/opportunities', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            navigate('/opportunities')
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}


export const editOpportunity = async (formValues, succesMsg, errorMsg) => {
    try {

        const { data } = await faradayApi.put('/opportunities', formValues)

        if (data.status === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: `${succesMsg}`,
                icon: "success",
            })
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }

    } catch (error) {
        console.log(error)

        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false

    }
}

export const deleteOpportunity = async (e, succesMsg, errorMsg, cancelButton, confirmButton, deleteConfirm )=> {
    const { value } = await Swal.fire({
        text: `${deleteConfirm} ${e.row.startup}`,
        showCancelButton: true,
        confirmButtonColor: '#001B60',
        cancelButtonText: cancelButton,
        confirmButtonText: confirmButton,
        reverseButtons: true
    })
    value && onConfirm(e.row.id, succesMsg, errorMsg , e.row.startup)
}

const onConfirm = async (id, succesMsg, errorMsg, startup) => {

    const { data } = await faradayApi.delete('/opportunities', { data: { id } });

    data.data !== 0 && !data.error ?
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: `${startup} ${succesMsg}`,
            icon: "success",
        })
        :
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: errorMsg,
            icon: "error",
        })
}

export const createRound = async (formValues, succesMsg, errorMsg, navigate) => {

    try {
        const { data } = await faradayApi.post('/opportunities/investmentOpportunities', formValues)

        if (data.ok === true) {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: succesMsg,
                icon: "success",
            })
            navigate(-1)
            return true
        } else {
            Swal.fire({
                confirmButtonColor: '#001B60',
                text: errorMsg,
                icon: "error",
                iconColor: '#FF7765'
            })
            return false
        }
    } catch (error) {
        console.log(error)
        Swal.fire({
            confirmButtonColor: '#001B60',
            text: error,
            icon: "error",
            iconColor: '#FF7765'
        })
        return false
    }
}